import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styles from './NavBarLink.module.scss';
import './NavBarLink.plain.scss';

function NavBarLink({
  disabled,
  dark,
  className,
  onClick,
  showUnderline = true,
  isExtraUrlMatch,
  ...otherProps
}) {
  const activeClassName = showUnderline
    ? 'nav-bar-link'
    : 'nav-bar-link-no-line';

  const classes = classNames(
    activeClassName,
    styles.link,
    dark && styles.dark,
    disabled && styles.disabled,
    className,
  );

  return (
    <NavLink
      disabled={disabled}
      className={({ isActive }) =>
        `${classes} ${isActive || isExtraUrlMatch ? 'active' : ''}`
      }
      onClick={onClick}
      {...otherProps}
    />
  );
}

export default memo(NavBarLink);
